import { put, call } from "redux-saga/effects";
import { toast } from "react-toastify";
import { Creators as AuthActions } from "../ducks/auth";
import { Creators as SignUpActions } from "../ducks/signup";
import api from "../../services/api";
import { format } from 'date-fns'
import { Creators as CartActions } from "../ducks/cart";
import { syncLocalCartToAPI } from "../../services/cart";

export function* signUp({ payload }) {
  const {
    cpf,
    nome,
    email,
    senha,
    dataNascimento,
    celular,
    genero,
    programaFidelidade,
    lgpd_aceite,
    aceitaOfertas
  } = payload;

  const cpfFormatted = cpf.replace(/[^\d]+/g, "");
  const celularFormatted = celular.replace(/[^\d]+/g, "");

  let cliente = null;

  // Etapa 1 — cadastro. Só o que acontece aqui pode reprovar o fluxo.
  try {
    const { data } = yield call(api.post, "/customers", {
      cpf: cpfFormatted,
      nome,
      email,
      senha,
      dataNascimento,
      celular: celularFormatted,
      genero,
      programaFidelidade,
      lgpd_aceite,
      ip: '',
      lgpd_data_aceite: format(new Date(), 'yyyy-MM-dd'),
      aceitaOfertas,
    });

    cliente = data?.cliente;
  } catch (err) {
    yield toast.error(err.response?.data?.error || 'Falha ao tentar realizar o login automático da sua conta');
    yield put(SignUpActions.signUpFailure());
    yield put(AuthActions.signFailure());
    return;
  }

  yield put(AuthActions.signInSuccess(cliente));

  // Etapa 2 — carrinho. Best-effort, mesmo racional de sagas/auth.js: uma falha
  // aqui não reprova o cadastro nem descarta o carrinho de convidado.
  try {
    yield syncLocalCartToAPI(cliente?.uuid)
  } catch (err) {
    console.error('[cart-sync] falha ao sincronizar a cesta no cadastro', {
      status: err.response?.status,
      url: err.config?.url,
      message: err.message
    });
  }

  yield put(CartActions.syncCartToLocalStorage(true));

  yield put(SignUpActions.signUpSuccess());

  yield toast.success("Cadastro efetuado com sucesso!")
}
